export const LOGIN_CONSTANT = {
  VALIDATION_USERNAME: '* Type Your Username First',
  VALIDATION_PASSWORD: '* Type Your Password First',

  PLACEHOLDER_USERNAME: 'Type Your Username',
  PLACEHOLDER_PASSWORD: 'Type Your Password',

  BUTTON_LOGIN: 'LOGIN',

  NOTIFICATION_ERROR_TITLE: 'Error!',
  NOTIFICATION_ERROR_CONTENT_LOGIN: 'Login Failed',
  NOTIFICATION_ERROR_CONTENT_DETAIL_LOGIN: 'There is a problem with our server',

  LOGIN_ERROR_USERNAME: 'Please enter a valid email address!',
  LOGIN_ERROR_PASSWORD: 'Password not match',
}